import { render, staticRenderFns } from "./bidEdit.vue?vue&type=template&id=5c0ae7fd&scoped=true"
import script from "./bidEdit.vue?vue&type=script&lang=js"
export * from "./bidEdit.vue?vue&type=script&lang=js"
import style0 from "./bidEdit.vue?vue&type=style&index=0&id=5c0ae7fd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0ae7fd",
  null
  
)

export default component.exports